import { Converter } from "../../interface/converter.interface";

	/**
	 * @description
	 *	Convertidor identidad: devuelve el mismo valor recibido, sin aplicar
	 *	ninguna modificación sobre el mismo, en cualquier etapa de su
	 *	procesamiento.
	 */

export class IdentityConverter<T = any> implements Converter<T, T> {

	constructor() {}

	public preConvert(value: T): T {
		return value;
	}

	public postConvert(value: T): T {
		return value;
	}
}
